import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/**
 * One colour per brand so Wheelabrator and DISA conversations are
 * distinguishable at a glance — the two catalogs must never be confused.
 *
 * `brand` arrives from the API as a plain string (the literal union only exists
 * on the create-conversation request), so unknown values get a neutral style
 * instead of no badge at all.
 */
const BRAND_STYLES: Record<string, string> = {
  Wheelabrator: "bg-blue-100 text-blue-800 border-blue-200",
  DISA: "bg-purple-100 text-purple-800 border-purple-200",
};

const FALLBACK_STYLE = "bg-background text-muted border-border";

interface BrandBadgeProps {
  /** Brand the conversation is pinned to (`ChatConversationSummary.brand`). */
  brand: string;
  className?: string;
}

/**
 * Small pill naming the brand a conversation is permanently pinned to. Used in
 * the conversation list and the chat header so the active brand context is
 * always visible.
 */
export function BrandBadge({ brand, className }: BrandBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "shrink-0 text-[10px] tracking-wide uppercase",
        BRAND_STYLES[brand] ?? FALLBACK_STYLE,
        className,
      )}
      title={`Brand: ${brand}`}
    >
      {brand}
    </Badge>
  );
}
